import React, { useState } from 'react';
import { Button, Container, Grid, Hidden, LinearProgress, makeStyles, Paper, Typography } from '@material-ui/core';
import AccountCustRPTForm from './accountCustRPT-form';
import { uri } from '../../../help/Api';
import { useHistory } from 'react-router-dom';
import ScannerIcon from '@material-ui/icons/Scanner';
import KeyboardReturnSharpIcon from '@material-ui/icons/KeyboardReturnSharp';
import PrintIcon from '@material-ui/icons/Print';
import { useStylesSpDial, useStylesUiElemment } from '../../../St/Reports/UseStyle';
import BalanceCard from '../../../components/BalanceCard';
import moment from 'moment';
import { insh as inshst } from '../../../Context/InshSt';
import { SAdefaultValues } from '../../Accounts/BackEnd/AccountingRPT/accountingRPT-services';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import toast from 'react-hot-toast';
import RevAccounting from '../../../Reviews/Accounts/Balance/RevAccounting';
import AccountsRPTTable from '../../Accounts/BackEnd/AccountingRPT/AccountsRPTTable';
import InvoicesDialogs from '../../Invs/BackEnd/Invoices/InvoicesDialogs';
import EReceiptVoucherDialog from '../../Accounts/BackEnd/receipt-voucher/external-receipt-voucher/EReceiptVoucherDialog';
import EExchangeVoucherDialog from '../../Accounts/BackEnd/receipt-voucher/external-exchange-voucher/EExchangeVoucherDialog';
import IExchangeVoucherDialog from '../../Accounts/BackEnd/receipt-voucher/internal-exchange-voucher/IExchangeVoucherDialog';
import ReceiptVoucherDialog from '../../Accounts/BackEnd/receipt-voucher/internal-receipt-voucher/ReceiptVoucherDialog';
import RestrictionDailogCon from '../../Accounts/BackEnd/Restriction/RestrictionDailogCon';
import ORestrictionsDialog from '../../Accounts/BackEnd/opening-restrictions/ORestrictionsDialog';
import { MultiQabdDataDialog, MultiSarfDataDialog } from '../../Accounts/BackEnd/receipt-voucher/multi-receipt-voucher/MVCon';
import RestInfoDialog from '../../Invs/BackEnd/models/RestInfo/RestInfoDialog';
import { GetItemFromOptions } from '../../../services/global-services';
import { excelHeadersAccount } from '../../Accounts/BackEnd/AccountingRPT/accountingRPT';
import { CSVLink } from 'react-csv';
import { TableChart } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#faf1f1',
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
  },

  headerTitle: {
    backgroundColor: '#ffffff',
    textAlign: 'center',
    fontSize: 20,
    width: '100%'
  },

  blCard: {
    backgroundColor: '#fff',
    borderColor: '#81007f'
  },

}));


export default function AccountCustRPT(props) {
  const { AutoOptions } = props;
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";
  const [rptParams, setRptParams] = React.useState({
    ...SAdefaultValues,
    dateFrom: from_date,
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    account: AutoOptions?.Accindex[0]
  });
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [sum, setSum] = useState(false);
  const { t } = useTranslation(['forms', 'translation']);
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };

  const viewHandle = async () => {
    if (rptParams.account.id == -1) return
    setSum(true)
    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `AccountReports/rptAccBalance?acc_no=${rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center?.id}
    &&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}
    &&orderType=${rptParams.orderType.id}
    &&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
      )
      .then((res) => {
        const dataItems = res.data.AccountBalance.map((row, i) => {
          return {
            ...row,
            no: i + 1,
            centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
          };
        });
        setData({ ...res.data, AccountBalance: dataItems });
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        toast.err("يوجد خطأ في الجلب");
        setData([]);
      });
  };
  const [style, setStyle] = useState(inshst.custm);
  const his = useHistory();
  const toBack = () => { his.push({ pathname: '/', }); };
  const printHandle = () => {
    const info = {
      data: data?.AccountBalance,
      tot: data?.totals,
      from: "الحساب",
      title: "حركة حساب خلال فترة",
      auto: {},
      account: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      balance: parseFloat(data?.totals?.totBlncDept ?? 0)
        - parseFloat(data?.totals?.totBlncCredit ?? 0),
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: false,
    };
    setDataPrint(info);
    setInfoPrint(true);
  }
  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  }
  const [invData, setInvData] = useState({});
  const [infoData, setInfoData] = useState({ open: false, rest_id: 0, branch: 0 });
  const [isOpenInv, setIsOpenInv] = useState(false);
  const [isOpenSandQ, setIsOpenSandQ] = useState(false);
  const [isOpenSandS, setIsOpenSandS] = useState(false);
  const [isOpenSandSD, setIsOpenSandSD] = useState(false);
  const [isOpenSandQD, setIsOpenSandQD] = useState(false);
  const [isOpenDailyRest, setIsOpenDailyRest] = useState(false);
  const [isOpenFirstRest, setIsOpenFirstRest] = useState(false);
  const [isOpenMultiSarf, setIsOpenMultiSarf] = useState(false);
  const [isOpenMultiQbd, setIsOpenMultiQbd] = useState(false);
  const [allow, setAllow] = useState({ inv: false, sqbd: false, sandQD: false, ssrf: false, sandSD: false, dailyRes: false, FirstRest: false, multiSarf: false, multiQbd: false });
  const handleOpenInvData = () => {
    setAllow({ ...allow, inv: !isOpenInv });
    setIsOpenInv(!isOpenInv);
  }; // E rsa

  const handleOpenSandQData = () => {
    setAllow({ ...allow, sqbd: !isOpenSandQ });
    setIsOpenSandQ(!isOpenSandQ);
  }; // E rsa
  const handleOpenSandSData = () => {
    setAllow({ ...allow, ssrf: !isOpenSandS });
    setIsOpenSandS(!isOpenSandS);
  }; // E rsa
  const handleOpenSandSDData = () => {
    setAllow({ ...allow, sandSD: !isOpenSandSD });
    setIsOpenSandSD(!isOpenSandSD);
  }; // E rsa
  const handleOpenSandQDData = () => {
    setAllow({ ...allow, sandQD: !isOpenSandQD });
    setIsOpenSandQD(!isOpenSandQD);
  }; // E rsa
  const handleOpenDailyRest = () => {
    setAllow({ ...allow, dailyRes: !isOpenDailyRest });
    setIsOpenDailyRest(!isOpenDailyRest);
  }; // E rsa
  const handleOpenFirstRest = () => {
    setAllow({ ...allow, FirstRest: !isOpenFirstRest });
    setIsOpenFirstRest(!isOpenFirstRest);
  }; // E rsa
  const handleOpenMultiSarf = () => {
    setAllow({ ...allow, multiSarf: !isOpenMultiSarf });
    setIsOpenMultiSarf(!isOpenMultiSarf);
  }; // E rsa

  const handleOpenMultiQbd = () => {
    setAllow({ ...allow, multiQbd: !isOpenMultiQbd });
    setIsOpenMultiQbd(!isOpenMultiQbd);
  }; // E rsa

  return (
    <div
      className={classes.root}>
      <Grid container item xs={12}>
        <Typography size="small" className={classes.headerTitle} >
          {t('translation:' + props.title)}
        </Typography>
      </Grid>
      <Typography component="div" style={{ direction: 'rtl' }} >
        <Container component={Paper} maxWidth={false}
          style={{
            padding: '10px',
            paddingBottom: '0px',
            borderBottomColor: inshst.colors.cust,
            borderBottomWidth: '10px',
            borderBottomStyle: 'solid'
          }}
        >

          <AccountCustRPTForm {...{ AutoOptions, rptParams, setRptParams, onChangeData, onChangeAutoData, printHandle }} />
          <Grid container justifyContent="center" lg={12} md={12} sm={12} xs={12} spacing={1} >
            <Grid item >
              <Button disabled={fetching} variant="contained"
                startIcon={<ScannerIcon />} size="large"
                style={{ ...style.iconBtn, borderRadius: 0 }}
                className={clasui.button}
                onClick={() => viewHandle()}>{t('forms:view')}</Button>
            </Grid>
            <Grid item >
              <Button disabled={fetching} variant="contained" startIcon={<PrintIcon />} color="primary" size="large"
                className={[clasui.button, clasSp.clSec]}
                style={{ ...style.iconBtn, borderRadius: 0 }}
                onClick={printHandle}>{t('forms:print')}</Button>
            </Grid>
            <Hidden only={["xs"]}>
              <Grid item >
                {data && !fetching && data.AccountBalance && (
                  <CSVLink
                    separator={";"}
                    filename={"AccountsReports"}
                    data={data.AccountBalance}
                    headers={excelHeadersAccount}
                  >
                    {" "}
                    <Button
                      disabled={fetching}
                      variant="contained"
                      startIcon={<TableChart />}
                      size="large"
                      style={{ ...style.iconBtn, borderRadius: 0 }}
                      className={[clasui.button]}
                    >
                      {"تصدير اكسل"}{" "}
                    </Button>
                  </CSVLink>
                )}
              </Grid>
            </Hidden>
            <Hidden smUp>
              <Grid item >
                {data && !fetching && data.AccountBalance && (
                  <CSVLink
                    separator={";"}
                    filename={"AccountsReports"}
                    data={data.AccountBalance}
                    headers={excelHeadersAccount}
                  >
                    {" "}
                    <Button
                      disabled={fetching}
                      variant="contained"
                      startIcon={<TableChart />}
                      size="large"
                      style={{ ...style.iconBtn, borderRadius: 0 }}
                      className={[clasui.button]}
                    >
                      {"اكسل"}{" "}
                    </Button>
                  </CSVLink>
                )}
              </Grid>
            </Hidden>
            <Grid item >
              <Button variant="contained" startIcon={<KeyboardReturnSharpIcon />} color="secondary" size="large"
                className={[clasui.button, clasSp.clcan]}
                style={{ ...style.iconBtn, borderRadius: 0 }}
                onClick={toBack}>{t('forms:exit')}</Button>
            </Grid>
          </Grid>
        </Container>

        <Container maxWidth={true} style={{ padding: '5px' }}>
          <Grid container spacing={0} justifyContent="center" style={{ paddingTop: '10px' }}>
            <Grid item lg={6} md={6} sm={6} xs={6} >
              <BalanceCard {...{
                title: t("acc-peroid-balance"),
                dept: data?.totals?.totBlncDept ?? 0,
                className: classes.blCard,
                credit: data?.totals?.totBlncCredit ?? 0,
              }} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6} >
              <BalanceCard {...{
                // title:'الدين المتبقي', 
                title: t("acc-peroid-total"),
                className: classes.blCard,
                dept: data?.totals?.totDept ?? 0,
                credit: data?.totals?.totCredit ?? 0,
              }} />
            </Grid>

          </Grid>
        </Container>
        <Container component={Paper} maxWidth={false}
          style={{
            padding: '10px',
            // paddingTop:'5px', 
          }}
        >
          <Grid container >
            {
              fetching ? <Paper >
                {'يرجى الانتظار قليلا حتى يتم جلب البيانات ...'}
                <LinearProgress />

              </Paper>
                :
                <AccountsRPTTable
                  {...{
                    data: data?.AccountBalance ? data?.AccountBalance : [], setInvData, handleOpenInvData, handleOpenSandQData, handleOpenSandSData
                    , handleOpenSandSDData, handleOpenSandQDData, handleOpenDailyRest, handleOpenFirstRest,
                    handleOpenMultiSarf, handleOpenMultiQbd, infoData, setInfoData, AutoOptions, color: inshst.colors.cust,
                  }}
                />
            }
          </Grid>
        </Container>
        {
          allow.inv ? (
            <InvoicesDialogs
              open={isOpenInv}
              onClose={() => {
                setIsOpenInv(false);
              }}
              onSave={() => {
                setIsOpenInv(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.sqbd ? (
            <EReceiptVoucherDialog
              open={isOpenSandQ}
              onClose={() => {
                setIsOpenSandQ(false);
              }}
              onSave={() => {
                setIsOpenSandQ(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.ssrf ? (
            <EExchangeVoucherDialog
              open={isOpenSandS}
              onClose={() => {
                setIsOpenSandS(false);
              }}
              onSave={() => {
                setIsOpenSandS(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.sandSD ? (
            <IExchangeVoucherDialog
              open={isOpenSandSD}
              onClose={() => {
                setIsOpenSandSD(false);
              }}
              onSave={() => {
                setIsOpenSandSD(false);
              }}
              invData={invData}
            />
          ) : null}

        {
          allow.sandQD ? (
            <ReceiptVoucherDialog
              open={isOpenSandQD}
              onClose={() => {
                setIsOpenSandQD(false);
              }}
              onSave={() => {
                setIsOpenSandQD(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.dailyRes ? (
            <RestrictionDailogCon
              open={isOpenDailyRest}
              onClose={() => {
                setIsOpenDailyRest(false);
              }}
              onSave={() => {
                setIsOpenDailyRest(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.FirstRest ? (
            <ORestrictionsDialog
              open={isOpenFirstRest}
              onClose={() => {
                setIsOpenFirstRest(false);
              }}
              onSave={() => {
                setIsOpenFirstRest(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.multiSarf ? (
            <MultiSarfDataDialog
              open={isOpenMultiSarf}
              onClose={() => {
                setIsOpenMultiSarf(false);
              }}
              onSave={() => {
                setIsOpenMultiSarf(false);
              }}
              invData={invData}
            />
          ) : null}

        {
          allow.multiQbd ? (
            <MultiQabdDataDialog
              open={isOpenMultiQbd}
              onClose={() => {
                setIsOpenMultiQbd(false);
              }}
              onSave={() => {
                setIsOpenMultiQbd(false);
              }}
              invData={invData}
            />
          ) : null}
        {infoData.open &&
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={infoData.rest_id}
            branch={infoData.branch}
            fromInv={0}
            proc_id={0}
          />
        }
        {infoPrint ?
          <RevAccounting dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
      </Typography>
    </div>
  );




};